import { h } from "hyperapp";

export const Users = ({
  actions: { fetchUsers, setUser },
  disabled,
  loading,
  section,
  state: { clientID, userID, users },
}): JSX.Element => {
  return (
    <div class="col-sm-auto mb-3">
      <label for="timespan">Usuário</label>
      <select
        class="custom-select form-control"
        disabled={loading || disabled}
        id="timespan"
        onblur={event => setUser({ userID: event.target.value, section })}
        oncreate={() => fetchUsers({ clientID })}
        required
      >
        <option selected value="">
          Escolha um usuário
        </option>
        {users.map(user => {
          return (
            <option selected={user.id === userID} value={user.id}>
              {user.name}
            </option>
          );
        })}
      </select>
    </div>
  );
};
